module.exports = __webpack_public_path__ + "media/images/browser-logos/chrome-2dafb709f0f811b90fe982065329ce3d.png";